var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: "Visualizar processo",
        closeOutside: true,
        hasFooter: false,
        width: 1000
      },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("VisualizarCadastro", {
            attrs: {
              protocolo: _vm.protocolo,
              cadastroContainerCustomClasses: _vm.cadastroContainerCustomClasses
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a611cbde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a611cbde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/AppModalVisualizarCadastro.vue
// module id = null
// module chunks = 